import {
  CLEAR_USAGE_SUMMARY_PAGE_STATE,
  SET_BROADBAND_ID,
  SET_SELECTED_DAILY_USAGE_MONTH,
  SET_SELECTED_SELECTED_PACKAGE_TYPE,
  SET_SELECTED_USAGE_PAGE_INDEX,
} from '../../const/actionTypes';
import { EPackageType } from '../../interfaces/packageType';

interface IInitialState {
  selectedUsageIndex: number;
  selectedPackageType: EPackageType | [];
  broadbandId: string;
  selectedDailyUsageMonth: number;
}

const initialState: IInitialState = {
  selectedUsageIndex: 0,
  selectedPackageType: [],
  broadbandId: '',
  selectedDailyUsageMonth: 0,
};

export type UsageSummaryPageState = Readonly<typeof initialState>;

const usageSummaryPageReducer = (
  state = initialState,
  action: any
): UsageSummaryPageState => {
  switch (action.type) {
    case SET_SELECTED_USAGE_PAGE_INDEX:
      return {
        ...state,
        selectedUsageIndex: action.payload.index,
      };

    case SET_SELECTED_SELECTED_PACKAGE_TYPE:
      return {
        ...state,
        selectedPackageType: action.payload.type,
      };

    case SET_BROADBAND_ID:
      return {
        ...state,
        broadbandId: action.payload.id,
      };

    case SET_SELECTED_DAILY_USAGE_MONTH:
      return {
        ...state,
        selectedDailyUsageMonth: action.payload.index,
      };

    case CLEAR_USAGE_SUMMARY_PAGE_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default usageSummaryPageReducer;
